import {
  CLEAR_TICKET_EVENT_DETAILS,
  CLEAR_TICKET_EVENT_PERFORMANCES,
  DYNAMIC_SEAT_MAP_DIRTY,
  EntertainmentDetailsPageActions,
  GET_TICKET_EVENT_DETAILS,
  GET_TICKET_EVENT_DETAILS_FAILURE,
  GET_TICKET_EVENT_DETAILS_SUCCESS,
  GET_TICKET_EVENT_PERFORMANCES,
  GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY,
  GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_FAILURE,
  GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_SUCCESS,
  GET_TICKET_EVENT_PERFORMANCES_FAILURE,
  GET_TICKET_EVENT_PERFORMANCES_SUCCESS,
  RESERVE_TICKETS_FAILURE,
  RESERVE_TICKETS_SUCCESS,
} from '../actions';
import { EntertainmentTicketDetailsState } from './index';

export const initialState: EntertainmentTicketDetailsState = {
  eventDetails: null,
  loaded: false,
  loading: false,
  calendarDetails: {
    isCalendarLoaded: false,
    isCalendarLoading: true,
    performances: null,
  },
  performancesAvailability: {
    isPerformanceAvailabilityLoaded: false,
    isPerformanceAvailabilityLoading: true,
    performancesAvailability: null,
  },
  reserveTickets: null,
  dynamicSeatMapDirty: false,
};

export function reducer(
  state = initialState,
  action: EntertainmentDetailsPageActions
): EntertainmentTicketDetailsState {
  switch (action.type) {
    case GET_TICKET_EVENT_DETAILS:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case GET_TICKET_EVENT_PERFORMANCES:
      return {
        ...state,
        calendarDetails: {
          ...state.calendarDetails,
          isCalendarLoaded: false,
          isCalendarLoading: true,
        },
      };

    case GET_TICKET_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        eventDetails: action.eventDetails,
      };

    case GET_TICKET_EVENT_DETAILS_FAILURE:
    case CLEAR_TICKET_EVENT_DETAILS:
    case GET_TICKET_EVENT_PERFORMANCES_FAILURE:
    case CLEAR_TICKET_EVENT_PERFORMANCES:
    case GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_FAILURE:
    case RESERVE_TICKETS_FAILURE:
      return initialState;

    case GET_TICKET_EVENT_PERFORMANCES_SUCCESS:
      return {
        ...state,
        calendarDetails: {
          ...state.calendarDetails,
          isCalendarLoaded: true,
          isCalendarLoading: false,
          performances: action.performances,
        },
      };

    case GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY: {
      return {
        ...state,
        performancesAvailability: {
          isPerformanceAvailabilityLoaded: false,
          isPerformanceAvailabilityLoading: true,
          performancesAvailability: null,
        },
      };
    }

    case GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        performancesAvailability: {
          isPerformanceAvailabilityLoaded: true,
          isPerformanceAvailabilityLoading: false,
          performancesAvailability: action.performancesAvailability,
        },
      };

    case RESERVE_TICKETS_SUCCESS:
      return {
        ...state,
        reserveTickets: {
          data: action.reserveTickets,
          paymentToken: action.paymentToken,
          performanceId: action.performanceId,
        },
      };

    case DYNAMIC_SEAT_MAP_DIRTY:
      return {
        ...state,
        dynamicSeatMapDirty: action.dirty,
      };

    default:
      return state;
  }
}
